import { RavelMessages } from "../../core/modules/RavelMessages.js";
import "../../core/web-components/index.js";

// For handling anchors

document.addEventListener('DOMContentLoaded', () => {
    const anchor = location.hash.slice(1);
    if (anchor) RavelMessages.sendMessage('scrapbook', 'open', anchor);
});

// For the embedded Thompson Folk Motif tool:
let folkMotifItems = [ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ];
		
function chooseTenFolkMotifItems() {
  for ( i=0; i < 10; i++) {
    if (folkMotifItems[i] != 0) document.getElementById("a" + folkMotifItems[i]).style['display'] = "none";
    folkMotifItems[i] = Math.floor(Math.random() * 42355) + 1;
    document.getElementById("a" + folkMotifItems[i]).style['display'] = "block";
  }
}

const fluxlyAsciiLogo = `
                                                    
             @@@@@@@@@@@@@@@@@@@@@                  
         @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@             
       @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@          
     @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@        
    @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@      
   @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@*-::::::+%@@@@     
   @@@@@@@@@@#****#@@@@@@@@@@@@+-:::....:::-#@@@    
  @@@@@@@@*-:::::::-=%@@@@@@@@=::.....-:...::*@@@   
 @@@@@@@%-::..::...::-%@@@@@@#::...=@@@@@-..::#@@@  
 @@@@@@%=:..=@@@@@:.::-@@@@@@=::..=@@@@@@@=..:-@@@@ 
 @@@@@@+::.-@@@@@@%..::@@@@@@-:...@@@@@@@@@:.::%@@@ 
 @@@@@@+:..=@@@@@@@..::@@@@@@=::..@@@@@@@@@..::@@@@@
 @@@@@@+:..-%@@@@@:..:-@@@@@@%::..-@@@@@@%:.::+@@@@@
 @@@@@@#-:...-*+:...::%@@@@@@@=::...:*#=...::-%@@@@@
 @@@@@@@#::........::*@@@@@@@@@*-:::.....:::=%@@@@@@
 @@@@@@@@@+::::::::-%@@@@@@@@@@@@%*=::::::-#@@@@@@@@
 @@@@@@@@@@@%+::-#@@@@@@@@@@@@@@@@@@@@@%@@@@@@@@@@@ 
 @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ 
  @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ 
  @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@  
   @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@   
     @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@    
      @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@     
        @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@      
          @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@         
              @@@@@@@@@@@@@@@@@@@@@@@@@@            
                    @@@@@@@@@@@                     
`;
console.log(fluxlyAsciiLogo);

